import { LeaveApprovalStatusEnum } from '@gtpl/shared-models/common-models';
import { TransactionDto } from './transactions.dto';

export class RequestFormDto {
    requestId: number;
    visitType: string;
    employeeName: string;
    employeeCode: number;
    department: string;
    visitorName: string;
    visitorCard: string;
    visitorEmail: string;
    visitorMobileNumber: string;
    aadharNumber: string;
    visitorAddress: string;
    visitorArrivalDate: any;
    visitorDepartureDate: any;
    purposeOfVisit: string;
    whomMeet: string;
    transportation: string;
    vehicleNumber: string;
    driverName: string;
    statusByHod: LeaveApprovalStatusEnum;
    statusByHr: LeaveApprovalStatusEnum;
    rejectionReason: string;
    createdUser: string;
    isActive: boolean;
    updatedUser?: string;
    versionFlag?: number;
    pastTransactios ?:TransactionDto[];
    
    
    constructor(
        requestId: number, 
        visitType: string,
        employeeName: string,
        employeeCode: number, 
        department: string,     
        visitorName: string,
        visitorCard: string,
        visitorEmail: string,
        visitorMobileNumber: string,
        aadharNumber: string,
        visitorAddress: string,
        visitorArrivalDate: any,
        visitorDepartureDate: any,
        purposeOfVisit: string,
        whomMeet: string,
        transportation: string,
        vehicleNumber: string,
        driverName: string,
        statusByHod: LeaveApprovalStatusEnum,
        statusByHr: LeaveApprovalStatusEnum, 
        rejectionReason: string,
        createdUser: string, 
        isActive: boolean, 
        updatedUser?: string, 
        versionFlag?: number,
        pastTransactios ?:TransactionDto[]
    ) {
        this.requestId= requestId;
        this.visitType= visitType;
        this.employeeName= employeeName;
        this.employeeCode= employeeCode;
        this.department= department;
        this.visitorName= visitorName;
        this.visitorCard= visitorCard;
        this.visitorEmail= visitorEmail;
        this.visitorMobileNumber= visitorMobileNumber;
        this.aadharNumber= aadharNumber;
        this.visitorAddress= visitorAddress;
        this.visitorArrivalDate= visitorArrivalDate;
        this.visitorDepartureDate= visitorDepartureDate;
        this.purposeOfVisit= purposeOfVisit;
        this.whomMeet= whomMeet;
        this.transportation= transportation;
        this.vehicleNumber= vehicleNumber;
        this.driverName= driverName;
        this.statusByHod= statusByHod;
        this.statusByHr= statusByHr;
        this.rejectionReason= rejectionReason;
        this.createdUser = createdUser;
        this.isActive = isActive;
        this.updatedUser = updatedUser;
        this.versionFlag = versionFlag;
        this.pastTransactios = pastTransactios;
       
    }
    
}